import * as getList from './reducers/get-list';
import * as update from './reducers/update';
import * as move from './reducers/move';
import * as updateSelection from './reducers/update-selection';
import * as marketCreation from './reducers/market-template-creation';
import * as selectionCreation from './reducers/selection-template-creation';
import * as moveSelections from './reducers/move-selections';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    MARKET_TEMPLATES_GET_LIST_REQUEST: getList.request,
    MARKET_TEMPLATES_GET_LIST_ERROR: getList.error,
    MARKET_TEMPLATES_GET_LIST_FINISH: getList.finish,

    MARKET_TEMPLATES_UPDATE_REQUEST: update.request,
    MARKET_TEMPLATES_UPDATE_ERROR: update.error,
    MARKET_TEMPLATES_UPDATE_FINISH: update.finish,

    MARKET_TEMPLATES_UPDATE_SELECTION_REQUEST: updateSelection.request,
    MARKET_TEMPLATES_UPDATE_SELECTION_ERROR: updateSelection.error,
    MARKET_TEMPLATES_UPDATE_SELECTION_FINISH: updateSelection.finish,

    MARKET_TEMPLATES_MOVE_SELECTION_REQUEST: moveSelections.request,
    MARKET_TEMPLATES_MOVE_SELECTION_ERROR: moveSelections.error,
    MARKET_TEMPLATES_MOVE_SELECTION_FINISH: moveSelections.finish,

    MARKET_TEMPLATES_MOVE_REQUEST: move.request,
    MARKET_TEMPLATES_MOVE_ERROR: move.error,
    MARKET_TEMPLATES_MOVE_FINISH: move.finish,

    MARKET_TEMPLATES_CREATION_REQUEST: marketCreation.request,
    MARKET_TEMPLATES_CREATION_ERROR: marketCreation.error,
    MARKET_TEMPLATES_CREATION_FINISH: marketCreation.finish,

    SELECTION_TEMPLATES_CREATION_FINISH: selectionCreation.finish,

    MARKET_TEMPLATES_DATA: update.bulk,
});
